"use strict";

import { UIContainer } from "../uiContainer.js";
import { Helper } from "../../helpers/helperFunctions.js";

export class UITransformHandler {
    static updateContainerTransform(object,parentPreferredBounds) {
        parentPreferredBounds.width /= object.parentContainer.lossyScaleX ;
        parentPreferredBounds.height /= object.parentContainer.lossyScaleY;

        let parentRect = object.parentContainer.calculatedRect;

        if (parentRect === undefined) {
            parentRect = { bounds: { left: 0, bottom: 0, right: 0, top: 0 } };
        }

        if (object.rect.anchorX.min != object.rect.anchorX.max) {
            let left = parentRect.bounds.left;
            left += parentPreferredBounds.width * object.rect.anchorX.min;
            left += object.transformToUI(object.rect.marginX.left);

            let right = parentRect.bounds.left;
            right += parentPreferredBounds.width * object.rect.anchorX.max;
            right -= object.transformToUI(object.rect.marginX.right);
            
            object._width = right - left;
            object.x = Math.lerp(left, right, object.rect.pivot.x);

            object.calculatedRect.bounds.left = left - object.x;
            object.calculatedRect.bounds.right = right - object.x;
        } else {
            let left = parentRect.bounds.left;
            left += parentPreferredBounds.width * object.rect.anchorX.min;
            left += object.transformToUI(object.rect.position.x);

            object._width = object.transformToUI(object.rect.size.width);
            object.x = left;

            object.calculatedRect.bounds.left = object._width * (1 - object.rect.pivot.x) - object._width;
            object.calculatedRect.bounds.right = object._width * object.rect.pivot.x;
        }
        
        // Max is Top, Min is Bottom
        if (object.rect.anchorY.min != object.rect.anchorY.max) {
            let bottom = parentRect.bounds.bottom;
            bottom += parentPreferredBounds.height * object.rect.anchorY.min;
            bottom += object.transformToUI(object.rect.marginY.bottom);

            let top = parentRect.bounds.bottom;
            top += parentPreferredBounds.height * object.rect.anchorY.max;
            top -= object.transformToUI(object.rect.marginY.top);
            
            object._height = top - bottom;
            object.y = parentPreferredBounds.height - Math.lerp(bottom, top, object.rect.pivot.y);

            object.calculatedRect.bounds.bottom = object._height * (1 - object.rect.pivot.y);
            object.calculatedRect.bounds.top = object._height * object.rect.pivot.y;
        } else {
            let bottom = parentRect.bounds.bottom;
            bottom += parentPreferredBounds.height * object.rect.anchorY.min;
            bottom += object.transformToUI(object.rect.position.y);

            object._height = object.transformToUI(object.rect.size.height);
            object.y = parentPreferredBounds.height - bottom;

            object.calculatedRect.bounds.bottom = object._height - object._height * object.rect.pivot.y;
            object.calculatedRect.bounds.top = object._height + object._height * object.rect.pivot.y;
        }
        
        object.calculatedRect.center.x = object.x;
        object.calculatedRect.center.y = object.y;
    }

    static updateGraphicalTransform(object,parentPreferredBounds) {
        parentPreferredBounds.width /= object.parentContainer.lossyScaleX;
        parentPreferredBounds.height /= object.parentContainer.lossyScaleY;

        let parentRect = object.parentContainer.calculatedRect;

        if (object.rect.anchorX.min != object.rect.anchorX.max) {
            let left = parentRect.bounds.left;
            left += parentPreferredBounds.width * object.rect.anchorX.min;
            left += object.transformToUI(object.rect.marginX.left);

            let right = parentRect.bounds.left;
            right += parentPreferredBounds.width * object.rect.anchorX.max;
            right -= object.transformToUI(object.rect.marginX.right);
            
            object.width = right - left;
            object.x = Math.lerp(left, right, object.rect.pivot.x);
            object.anchor.x = object.rect.pivot.x;

            object.calculatedRect.bounds.left = left - object.x;
            object.calculatedRect.bounds.right = right - object.x;
        } else {
            let left = parentRect.bounds.left;
            left += parentPreferredBounds.width * object.rect.anchorX.min;
            left += object.transformToUI(object.rect.position.x);

            object.width = object.transformToUI(object.rect.size.width);
            object.x = left;
            object.anchor.x = object.rect.pivot.x;

            object.calculatedRect.bounds.left = object.width * (1 - object.rect.pivot.x) - object.width;
            object.calculatedRect.bounds.right = object.width * object.rect.pivot.x;
        }
        
        // Max is Top, Min is Bottom
        if (object.rect.anchorY.min != object.rect.anchorY.max) {
            let bottom = parentRect.bounds.bottom;
            bottom += parentPreferredBounds.height * object.rect.anchorY.min;
            bottom += object.transformToUI(object.rect.marginY.bottom);

            let top = parentRect.bounds.bottom;
            top += parentPreferredBounds.height * object.rect.anchorY.max;
            top -= object.transformToUI(object.rect.marginY.top);
            
            object.height = top - bottom;
            object.y = parentPreferredBounds.height - Math.lerp(bottom, top, object.rect.pivot.y);
            object.anchor.y = 1 - object.rect.pivot.y;

            object.calculatedRect.bounds.bottom = object.height * (1 - object.rect.pivot.y);
            object.calculatedRect.bounds.top = object.height * object.rect.pivot.y;
        } else {
            let bottom = parentRect.bounds.bottom;
            bottom += parentPreferredBounds.height * object.rect.anchorY.min;
            bottom += object.transformToUI(object.rect.position.y);

            object.height = object.transformToUI(object.rect.size.height);
            object.y = parentPreferredBounds.height - bottom;
            object.anchor.y = 1 - object.rect.pivot.y;

            object.calculatedRect.bounds.bottom = object.height - object.height * object.rect.pivot.y;
            object.calculatedRect.bounds.top = object.height + object.height * object.rect.pivot.y;
        }
        
        object.calculatedRect.center.x = object.x;
        object.calculatedRect.center.y = object.y;
    }

    static updateGraphicalNoAnchorTransform(object,parentPreferredBounds) {
        parentPreferredBounds.width /= object.parentContainer.lossyScaleX ;
        parentPreferredBounds.height /= object.parentContainer.lossyScaleY;

        let parentRect = object.parentContainer.calculatedRect;

        if (parentRect === undefined) {
            parentRect = { bounds: { left: 0, bottom: 0, right: 0, top: 0 } };
        }

        if (object.rect.anchorX.min != object.rect.anchorX.max) {
            let left = parentRect.bounds.left;
            left += parentPreferredBounds.width * object.rect.anchorX.min;
            left += object.transformToUI(object.rect.marginX.left);

            let right = parentRect.bounds.left;
            right += parentPreferredBounds.width * object.rect.anchorX.max;
            right -= object.transformToUI(object.rect.marginX.right);
            
            object.width = right - left;
            object.x = Math.lerp(left, right, object.rect.pivot.x);
            object.x -= object.width * object.rect.pivot.x;

            object.calculatedRect.bounds.left = left - object.x;
            object.calculatedRect.bounds.right = right - object.x;
        } else {
            let left = parentRect.bounds.left;
            left += parentPreferredBounds.width * object.rect.anchorX.min;
            left += object.transformToUI(object.rect.position.x);

            object.width = object.transformToUI(object.rect.size.width);
            object.x = left;
            object.x -= object.width * object.rect.pivot.x;

            object.calculatedRect.bounds.left = object.width * (1 - object.rect.pivot.x) - object.width;
            object.calculatedRect.bounds.right = object.width * object.rect.pivot.x;
        }
        
        // Max is Top, Min is Bottom
        if (object.rect.anchorY.min != object.rect.anchorY.max) {
            let bottom = parentRect.bounds.bottom;
            bottom += parentPreferredBounds.height * object.rect.anchorY.min;
            bottom += object.transformToUI(object.rect.marginY.bottom);

            let top = parentRect.bounds.bottom;
            top += parentPreferredBounds.height * object.rect.anchorY.max;
            top -= object.transformToUI(object.rect.marginY.top);
            
            object.height = top - bottom;
            object.y = parentPreferredBounds.height - Math.lerp(bottom, top, object.rect.pivot.y);
            object.y -= object.height * (1 - object.rect.pivot.y);

            object.calculatedRect.bounds.bottom = object.height * (1 - object.rect.pivot.y);
            object.calculatedRect.bounds.top = object.height * object.rect.pivot.y;
        } else {
            let bottom = parentRect.bounds.bottom;
            bottom += parentPreferredBounds.height * object.rect.anchorY.min;
            bottom += object.transformToUI(object.rect.position.y);

            object.height = object.transformToUI(object.rect.size.height);
            object.y = parentPreferredBounds.height - bottom;
            object.y -= object.height * (1 - object.rect.pivot.y);

            object.calculatedRect.bounds.bottom = object.height - object.height * object.rect.pivot.y;
            object.calculatedRect.bounds.top = object.height + object.height * object.rect.pivot.y;
        }
        
        object.calculatedRect.center.x = object.x;
        object.calculatedRect.center.y = object.y;
    }

    static ARWidthControlsHeight(object) {
        if (object instanceof UIContainer) {
            let currentHeight = object._height;
            object._height = object._width / object.preserveAspectRatio.ratio;
            object.y += (currentHeight - object._height) * (1 - object.rect.pivot.y);
        } else {
            object.height = object.width / object.preserveAspectRatio.ratio;
        }
    }
    static ARHeightControlsWidth(object) {
        if (object instanceof UIContainer) {
            let currentWidth = object._width;
            object._width = object._height / object.preserveAspectRatio.ratio;
            object.x += (currentWidth - object._width) * object.rect.pivot.x;
        } else {
            object.width = object.height * object.preserveAspectRatio.ratio;
        }
    }
    static ARFitInParent(object) {
        if (object instanceof UIContainer) {
            UITransformHandler._ARFitInParentContainer(object);
        } else {
            UITransformHandler._ARFitInParentGraphics(object);
        }
    }
    static _ARFitInParentContainer(object) {
        let currentWidth = object._width;
        let currentHeight = object._height;
        let currentAspectRatio = (currentWidth / currentHeight).fixPrecision();

        if (object.preserveAspectRatio.ratio <= currentAspectRatio) {
            object._width = currentHeight * object.preserveAspectRatio.ratio;
            object.x += (currentWidth - object._width) * object.rect.pivot.x;
        } else {
            object._height = currentWidth / object.preserveAspectRatio.ratio;
            object.y += (currentHeight - object._height) * (1 - object.rect.pivot.y);
        }
    }
    static _ARFitInParentGraphics(object) {
        let currentWidth = object.width;
        let currentHeight = object.height;
        let currentAspectRatio = (currentWidth / currentHeight).fixPrecision();

        if (object.preserveAspectRatio.ratio <= currentAspectRatio) {
            object.width = currentHeight * object.preserveAspectRatio.ratio;
        } else {
            object.height = currentWidth / object.preserveAspectRatio.ratio;
        }
    }
    static AREnvelopParent(object) {
        if (object instanceof UIContainer) return;

        let currentWidth = object.width;
        let currentHeight = object.height;
        let currentAspectRatio = (currentWidth / currentHeight).fixPrecision();

        if (object.preserveAspectRatio.ratio <= currentAspectRatio) {
            object.height = currentWidth / object.preserveAspectRatio.ratio;
            // object.y -= (currentHeight - object.height) * object.rect.pivot.y;
        } else {
            object.width = currentHeight * object.preserveAspectRatio.ratio;
            // object.x += (currentWidth - object.width) * object.rect.pivot.x;
        }
    }

    static setRect(object,newRect) {
        object.rect = {...object.rect,...newRect};
    }
}